import { IQuotePartExtraData } from 'quotes/types';

interface IQuotePartListServerData {
  // Still snake_case inside: mapRecordsFromServer camelCases the extra data.
  pending_cli_jobs?: IQuotePartExtraData['pendingCliJobs'];
  external_pricing_window_closed?: boolean;
  external_pricing_window_message?: string | null;
}

// The top-level window keys share their names with the line keys but mean the whole quote; the
// BE leaves them out when the quote has no lines.
export const mapQuotePartListExtraDataFromServer = (
  data: IQuotePartListServerData | null | undefined
): IQuotePartExtraData => ({
  pendingCliJobs: data?.pending_cli_jobs,
  pricingWindowClosed: !!data?.external_pricing_window_closed,
  pricingWindowMessage: data?.external_pricing_window_message || null,
});
